<template>
  <div class="container-anexos">
    <div class="header-anexos d-flex justify-content-between align-items-center mb-3">
      <h6>Anexos e Notas do Item</h6>
      <div class="acoes-header">
        <b-button size="sm" variant="outline-primary" :disabled="salvandoFoto || !editavel" @click="$refs.inputArquivo.click()">
          <i class="fa fa-camera mr-1"></i> Adicionar Foto
        </b-button>
        <input
          ref="inputArquivo"
          type="file"
          class="d-none"
          accept="image/*"
          multiple
          @change="handleFileUpload"
        />
      </div>
    </div>

    <div class="bloco-fotos mb-3">
      <h6 class="titulo-secao mb-2">Fotos</h6>
      <div v-if="anexosImagem.length" class="linha-fotos">
        <div v-for="anexo in anexosImagem" :key="anexo.itemBoletimMedicaoAnexoId" class="foto-item">
          <div class="thumbnail">
            <img :src="getUrlImagem(anexo.caminhoArquivo)" :alt="anexo.nomeArquivo" @click="visualizarImagem(anexo)" />
            <div class="overlay">
              <i class="fa fa-search-plus" title="Visualizar" @click="visualizarImagem(anexo)"></i>
              <i v-if="editavel" class="fa fa-trash text-danger ml-3" title="Excluir" @click="excluirFoto(anexo)"></i>
            </div>
          </div>
          <span class="nome-arquivo">{{ anexo.nomeArquivo }}</span>
        </div>
      </div>
      <div v-else class="sem-anexos">
        <p>Nenhuma foto para este subitem.</p>
      </div>
    </div>

    <div class="bloco-nota">
      <h6 class="titulo-secao mb-2">Nota do Subitem</h6>
      <b-form-textarea
        v-model="conteudoNota"
        rows="4"
        placeholder="Digite uma nota para este subitem..."
        :disabled="campoNotaBloqueado"
      ></b-form-textarea>

      <div class="rodape-nota mt-2">
        <small class="texto-data">{{ textoDataNota }}</small>
        <div class="acoes-nota">
          <b-button
            v-if="notaAtual"
            size="sm"
            variant="outline-danger"
            class="mr-2"
            :disabled="salvandoNota || !editavel"
            @click="excluirNota"
          >
            Excluir Nota
          </b-button>
          <b-button
            v-if="notaAtual && !modoEdicaoNota"
            size="sm"
            variant="primary"
            :disabled="salvandoNota || !editavel"
            @click="habilitarEdicaoNota"
          >
            Atualizar Nota
          </b-button>
          <b-button
            v-else
            size="sm"
            variant="primary"
            :disabled="!podeSalvarNota || salvandoNota || !editavel"
            @click="salvarNotaUnica"
          >
            <i v-if="salvandoNota" class="fa fa-spinner fa-spin mr-1"></i>
            Salvar
          </b-button>
        </div>
      </div>
    </div>

    <b-modal v-model="showModalImagem" hide-footer title="Visualizar Anexo" size="lg">
      <div class="text-center">
        <img :src="imagemSelecionada" class="img-fluid" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import MemoriaCalculoServicos from './MemoriaCalculoServicos'

export default {
  name: 'MemoriaCalculoAnexos',
  props: {
    anexos: {
      type: Array,
      default: () => []
    },
    contratoId: {
      type: [String, Number],
      required: true
    },
    boletimMedicaoId: {
      type: [String, Number],
      required: true
    },
    itemBoletimMedicaoId: {
      type: [String, Number],
      required: true
    },
    editavel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModalImagem: false,
      imagemSelecionada: '',
      conteudoNota: '',
      modoEdicaoNota: true,
      salvandoNota: false,
      salvandoFoto: false
    }
  },
  computed: {
    anexosOrdenados() {
      return [...this.anexos].sort((a, b) => a.ordem - b.ordem)
    },
    anexosImagem() {
      return this.anexosOrdenados.filter((anexo) => anexo.tipo === 2)
    },
    anexosTexto() {
      return this.anexosOrdenados.filter((anexo) => anexo.tipo === 1)
    },
    notaAtual() {
      if (!this.anexosTexto.length) return null
      return this.anexosTexto[this.anexosTexto.length - 1]
    },
    podeSalvarNota() {
      if (!this.modoEdicaoNota) return false
      const novoConteudo = (this.conteudoNota || '').trim()
      if (!novoConteudo) return false
      if (!this.notaAtual) return true
      return novoConteudo !== (this.notaAtual.conteudo || '').trim()
    },
    campoNotaBloqueado() {
      return !this.editavel || !this.modoEdicaoNota
    },
    textoDataNota() {
      if (!this.notaAtual) return 'Nenhuma nota cadastrada.'
      return `Ultima atualizacao: ${this.formatarData(this.notaAtual.dataInclusao)}`
    }
  },
  watch: {
    notaAtual: {
      immediate: true,
      handler(nota) {
        this.conteudoNota = (nota?.conteudo || '').trim()
        this.modoEdicaoNota = !nota
      }
    }
  },
  methods: {
    getUrlImagem(caminho) {
      if (!caminho) return ''

      const caminhoNormalizado = String(caminho).trim().replace(/\\/g, '/')
      const baseGescon = this.normalizarBaseGescon(process.env.VUE_APP_GESCON_API_URL)
      const caminhoDocRepositorio = this.extrairCaminhoDocRepositorio(caminhoNormalizado)

      if (this.isUrlAbsoluta(caminhoNormalizado)) {
        const urlComProtocoloCorreto = this.aplicarProtocoloPagina(caminhoNormalizado)

        if (this.isHostLocal(urlComProtocoloCorreto) && baseGescon && caminhoDocRepositorio) {
          return encodeURI(`${baseGescon}/${caminhoDocRepositorio}`)
        }

        return encodeURI(urlComProtocoloCorreto)
      }

      if (baseGescon) {
        return encodeURI(`${baseGescon}/${caminhoNormalizado.replace(/^\/+/, '')}`)
      }

      return encodeURI(`/${caminhoNormalizado.replace(/^\/+/, '')}`)
    },
    aplicarProtocoloPagina(url) {
      if (window.location.protocol === 'https:' && url.startsWith('http://')) {
        return url.replace(/^http:\/\//i, 'https://')
      }

      return url
    },
    normalizarBaseGescon(baseUrl) {
      if (!baseUrl) return ''

      return String(baseUrl)
        .trim()
        .replace(/\/+$/, '')
        .replace(/\/api(\/v\d+)?$/i, '')
    },
    isUrlAbsoluta(valor) {
      return /^https?:\/\//i.test(valor)
    },
    isHostLocal(url) {
      try {
        const hostname = new URL(url).hostname.toLowerCase()
        return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0'
      } catch (error) {
        return false
      }
    },
    extrairCaminhoDocRepositorio(caminho) {
      const match = caminho.match(/DocRepositorio\/.+$/i)
      return match ? match[0].replace(/^\/+/, '') : ''
    },
    formatarData(data) {
      if (!data) return ''
      return new Date(data).toLocaleString('pt-BR')
    },
    visualizarImagem(anexo) {
      this.imagemSelecionada = this.getUrlImagem(anexo.caminhoArquivo)
      this.showModalImagem = true
    },
    habilitarEdicaoNota() {
      if (!this.editavel) return
      this.modoEdicaoNota = true
    },
    async salvarNotaUnica() {
      if (!this.editavel) return
      const novoConteudo = (this.conteudoNota || '').trim()
      if (!novoConteudo) return

      const editando = !!this.notaAtual
      this.salvandoNota = true
      try {
        if (editando) {
          await MemoriaCalculoServicos.editarAnexoItem(
            this.contratoId,
            this.boletimMedicaoId,
            this.itemBoletimMedicaoId,
            this.notaAtual.itemBoletimMedicaoAnexoId,
            { Conteudo: novoConteudo }
          )
        } else {
          const formData = new FormData()
          formData.append('Tipo', 1)
          formData.append('Conteudo', novoConteudo)

          await MemoriaCalculoServicos.adicionarAnexoItem(
            this.contratoId,
            this.boletimMedicaoId,
            this.itemBoletimMedicaoId,
            formData
          )
        }

        this.$toast?.success(editando ? 'Nota atualizada com sucesso!' : 'Nota adicionada com sucesso!')
        this.modoEdicaoNota = false
        this.$emit('anexo-atualizado')
      } catch (error) {
        console.error('Erro ao salvar nota:', error)
        this.$toast?.error('Erro ao salvar nota.')
      } finally {
        this.salvandoNota = false
      }
    },
    async excluirNota() {
      if (!this.editavel) return
      if (!this.notaAtual) return

      const confirmacao = window.confirm('Deseja realmente excluir a nota?')
      if (!confirmacao) return

      try {
        await MemoriaCalculoServicos.excluirAnexoItem(
          this.contratoId,
          this.boletimMedicaoId,
          this.itemBoletimMedicaoId,
          this.notaAtual.itemBoletimMedicaoAnexoId
        )

        this.conteudoNota = ''
        this.modoEdicaoNota = true
        this.$toast?.success('Nota excluida com sucesso!')
        this.$emit('anexo-atualizado')
      } catch (error) {
        console.error('Erro ao excluir nota:', error)
        this.$toast?.error('Erro ao excluir nota.')
      }
    },
    async handleFileUpload(event) {
      if (!this.editavel) return
      const arquivos = Array.from(event.target.files || [])
      if (!arquivos.length) return

      const arquivosValidos = arquivos.filter((file) => file.size <= 2 * 1024 * 1024)
      const totalInvalidos = arquivos.length - arquivosValidos.length

      if (!arquivosValidos.length) {
        this.$toast?.error('Arquivo muito grande. O tamanho maximo permitido e 2MB.')
        this.$refs.inputArquivo.value = ''
        return
      }

      if (totalInvalidos > 0) {
        this.$toast?.warning(`${totalInvalidos} arquivo(s) ignorado(s) por ultrapassar 2MB.`)
      }

      this.salvandoFoto = true
      try {
        for (const file of arquivosValidos) {
          const formData = new FormData()
          formData.append('Tipo', 2)
          formData.append('Arquivo', file)

          await MemoriaCalculoServicos.adicionarAnexoItem(
            this.contratoId,
            this.boletimMedicaoId,
            this.itemBoletimMedicaoId,
            formData
          )
        }

        const sufixo = arquivosValidos.length > 1 ? 's' : ''
        this.$toast?.success(`Foto${sufixo} adicionada${sufixo} com sucesso!`)
        this.$emit('anexo-atualizado')
      } catch (error) {
        console.error('Erro ao fazer upload da imagem:', error)
        this.$toast?.error('Erro ao enviar imagem.')
      } finally {
        this.salvandoFoto = false
        this.$refs.inputArquivo.value = ''
      }
    },
    async excluirFoto(anexo) {
      if (!this.editavel) return
      const confirmacao = window.confirm('Deseja realmente excluir esta foto?')
      if (!confirmacao) return

      try {
        await MemoriaCalculoServicos.excluirAnexoItem(
          this.contratoId,
          this.boletimMedicaoId,
          this.itemBoletimMedicaoId,
          anexo.itemBoletimMedicaoAnexoId
        )

        this.$toast?.success('Foto excluida com sucesso!')
        this.$emit('anexo-atualizado')
      } catch (error) {
        console.error('Erro ao excluir foto:', error)
        this.$toast?.error('Erro ao excluir foto.')
      }
    }
  }
}
</script>

<style scoped>
.container-anexos {
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px dashed #ccc;
  width: 100%;
}

.header-anexos h6,
.titulo-secao {
  margin: 0;
  font-weight: 600;
  color: #495057;
}

.bloco-fotos,
.bloco-nota {
  width: 100%;
}

.linha-fotos {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.foto-item {
  width: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.thumbnail {
  position: relative;
  width: 130px;
  height: 130px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  background-color: #fff;
}

.thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumbnail .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.2s;
  color: #fff;
  font-size: 18px;
}

.thumbnail:hover .overlay {
  opacity: 1;
}

.nome-arquivo {
  font-size: 11px;
  color: #666;
  margin-top: 5px;
  text-align: center;
  width: 100%;
  word-break: break-word;
}

.rodape-nota {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.acoes-nota {
  display: flex;
  align-items: center;
}

.texto-data {
  color: #6c757d;
}

.sem-anexos {
  color: #999;
  font-style: italic;
  font-size: 13px;
  text-align: center;
  padding: 10px;
}

@media (max-width: 576px) {
  .foto-item,
  .thumbnail {
    width: 110px;
    height: 110px;
  }

  .rodape-nota {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
